module.exports = __webpack_public_path__ + "static/img/sz04.b3b3aedf.png";